import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/chart-of-accounts', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/chart-of-accounts', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/chart-of-accounts/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/chart-of-accounts/${data.account_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient.delete(`/api/chart-of-accounts/${id}`).then(response => Promise.resolve(response.data))
}

export const getaccounttype = (Options = {}) => {
  return httpClient.get('/api/chart-of-accounts/account-types', Option).then(response => Promise.resolve(response.data))
}

export const getparentaccount = (Options = {}) => {
  return httpClient
    .get('/api/chart-of-accounts/parent-accounts', Option)
    .then(response => Promise.resolve(response.data))
}

export default {
  get,
  store,
  find,
  update,
  destroy,
  getaccounttype,
  getparentaccount
}
